export function multipleCallback(callbacks) {
    return function () { return callbacks.forEach(function (cb) { return cb(); }); };
}
//# sourceMappingURL=multipleCallback.js.map